import React from "react";
import StripeLogo from "assets/logo/stripe.png";
import "./index.scss";

const Disclaimer = () => {
  return (
    <div className="payment-disclaimer">
      <img src={StripeLogo} alt="Order Payment" />
      <p className="text">
        Our payment transactions are always powered by stripe.
      </p>
    </div>
  );
};

export default Disclaimer;
